import LazyLoad from 'vanilla-lazyload';
import AOS from 'simple-aos';
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import '../components/parallax';
import createTextReveal from '../components/textReveal';

// initialize lazyload
const initLazyLoad = new LazyLoad();
initLazyLoad.update();

/*
 * * logos-media-swiper
 */
/* eslint-disable no-new */
const logosMedia = document.querySelector('.logos-swiper');
const logosMediaNumberOfSlides =
	logosMedia.querySelectorAll('.swiper-slide').length;
const logosMediaSwiper = new Swiper('.logos-swiper', {
	modules: [Autoplay],
	slidesPerView: 2,
	spaceBetween: 0,
	slidesPerGroup: 1,
	loop: true,
	speed: 3000,
	autoplay: {
		delay: 0,
		disableOnInteraction: false,
	},
	allowTouchMove: true,
	freeMode: {
		enabled: true,
		momentum: false,
	},
	loopAdditionalSlides: 2,
	breakpoints: {
		436: {
			slidesPerView: 3,
		},
		768: {
			slidesPerView: 5,
		},
		1024: {
			slidesPerView: logosMediaNumberOfSlides || 'auto',
			autoplay: {
				delay: 2000,
			},
			freeMode: {
				enabled: false,
			},
			loop: false,
		},
	},
});

// initialize AOS
AOS.init({
	disable: window.matchMedia('(prefers-reduced-motion: reduce)'), // reduce motion when user has set prefers-reduced-motion for accessibility
	easing: 'ease-in-out',
	duration: 800,
	offset: 80,
	anchorPlacement: 'top-bottom',
	once: true,
});

/*
 ** Text Reveal Animation from gray to white
 ** on scroll or after 3 seconds
 */

const customTextReveal = createTextReveal({
	selector: '.intro-text-color-reveal',
	delay: 30,
	autoStartDelay: 0,
	fromColor: 'var(--tbla-white)',
	toColor: 'var(--tbla-mint)',
});
